module.exports = __webpack_public_path__ + "static/media/github-white.1e143ca6.png";